import { useEffect, useRef, useState, useCallback } from "react"

/**
 * Custom hook to replace Chakra UI's deprecated useDimensions hook
 * @param {React.RefObject} ref - Optional ref object to measure. If not provided, creates its own ref.
 * @returns {[React.RefObject, object]} - Returns [ref, dimensions] where dimensions has borderBox property
 */
export default function useDimensions(ref) {
    const internalRef = useRef()
    const targetRef = ref || internalRef
    const [dimensions, setDimensions] = useState(null)

    const updateDimensions = useCallback(() => {
        if (targetRef.current) {
            const rect = targetRef.current.getBoundingClientRect()
            setDimensions({
                borderBox: {
                    width: rect.width,
                    height: rect.height,
                },
            })
        }
    }, [targetRef])

    useEffect(() => {
        // Initial measurement
        updateDimensions()
        
        // Add resize listener
        window.addEventListener("resize", updateDimensions)
        
        return () => window.removeEventListener("resize", updateDimensions)
    }, [updateDimensions])

    return ref ? dimensions : [targetRef, dimensions]
}